module.exports = __webpack_public_path__ + "static/quantum-safe-wallet-7f16ea3410a592ededbe44aec0c39d99.jpeg";